module.exports = __webpack_public_path__ + "static/media/tarifs.78960d26.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/gpi/form/tarifs.xlsx
// module id = 852
// module chunks = 40